/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import template from './networks-tab.component.html';
import {AUTH_EVENT} from '../../../components/auth/auth-constants';
import {AdnNetworkHelperService} from '../../../components/util/adn-network-helper.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {AuthHttpBufferService} from '../../../components/auth/auth-http-buffer.service';


@Component({
  standalone: false,
  selector: 'adn-networks-tab',
  template
})
export class NetworksTabComponent implements OnInit, OnDestroy {
  @Input() networks: any[];

  currentNetwork: any;
  networkSearchText = '';

  private networkChangeListener: () => void;

  constructor(
    private readonly eventBus: AppEventBusService,
    @Inject(AdnNetworkHelperService) private readonly adnNetworkHelper: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly authHttpBuffer: AuthHttpBufferService
  ) {
  }

  ngOnInit(): void {
    this.currentNetwork = _.find(this.networks, ['id', this.LocalNetworkProfile.get('networkId')]);
    this.networkChangeListener = this.eventBus.on(AUTH_EVENT.networkChange, (_event: any, network: any) => {
      this.currentNetwork = network;
    });
  }

  ngOnDestroy(): void {
    if (this.networkChangeListener) {
      this.networkChangeListener();
    }
  }

  get filteredNetworks(): any[] {
    if (!this.networks) {
      return [];
    }
    if (this.networks.length <= 15) {
      return this.networks;
    }
    const searchText = normalizeSearchText(this.networkSearchText);
    if (!searchText) {
      return this.networks;
    }
    return _.filter(this.networks, (network) => {
      const updatedName = normalizeSearchText(_.get(network, 'name', ''));
      const updatedId = normalizeSearchText(_.get(network, 'id', ''));
      const updatedTagId = normalizeSearchText(_.get(network, 'tagId', ''));
      return updatedName.indexOf(searchText) > -1 || updatedId.indexOf(searchText) > -1 || updatedTagId.indexOf(searchText) > -1;
    });
  }

  switchNetwork(network: any): void {
    if (this.authHttpBuffer.networkSwitchInProgress) {
      return;
    }
    this.adnNetworkHelper.switchNetwork(this, this.eventBus, network);
  }
}

function normalizeSearchText(value: string): string {
  return (value || '').replace(/ /g, '').replace(/_/g, '').toLowerCase();
}
